<template>
  <div id="app" class="clearfix">
    <router-view/>
    <transition appear mode='out-in' enter-active-class='animated animated2 slideInRight' leave-active-class='animated animated2 slideOutRight'>
      <div v-if="isShowGlobalRightBox" class="rightBox" @click.self="closeRightBoxFun">
        <component :closeRightBoxFun="closeRightBoxFun" :parameter="localCart" :obj="obj" :is="isCompnentElement"></component>
        <span class="guanbiBtn cursor" @click="closeRightBoxFun">
          <i class="iconfont icon-close"></i>
        </span>
      </div>
    </transition>
    <div class="jiazaiBox" v-if="isLoading">
      <span class="yuanjiao" v-if="isLoadingShow">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </span>
    </div>
  </div>
</template>

<script>
import uiAnli from '@/components/common/productinfo';
import uiWechat from '@/components/common/wechat';
import uiFangan from '@/components/common/fangan';
import uiDaohang from '@/components/common/daohang';
import generalMix from '@/util/mix/general';
import { EventBus } from '@/util/eventBus';

export default {
  name: 'App',
  mixins: [generalMix],
  data() {
    return {
      // 全局右侧视图框
      obj: '',
      isShowGlobalRightBox: false,
      isCompnentElement: '',
      isLoading:false,
      isLoadingShow:false
    };
  },
  methods:{
    closeRightBoxFun() {
      this.isShowGlobalRightBox = false;
      this.obj = '';
      this.isCompnentElement = '';
      $('html').removeClass('scrollHide');
    },
    showMenuFun() {
      this.isCompnentElement = 'ui-daohang';
      this.obj = {};
      this.isShowGlobalRightBox = true;
      $('html').addClass('scrollHide');
    },
    showModel() {
      this.isCompnentElement = 'ui-product-content';
      this.isShowGlobalRightBox = true;
      $('html').addClass('scrollHide');
    }
  },
  created() {
    const that = this;
    EventBus.$on('globalRightBoxFun', (ob) => {
      // 案例
      if (ob.type === 1) {
        that.isCompnentElement = 'ui-anli';
        that.obj = ob.obj;
        that.isShowGlobalRightBox = true;
      }
      // 微信二维码
      if (ob.type === 2) {
        that.isCompnentElement = 'ui-wechat';
        that.obj = ob.obj;
        that.isShowGlobalRightBox = true;
      }
      if (ob.type === 3) {
        that.isCompnentElement = 'ui-fangan';
        that.obj = ob.show;
        that.isShowGlobalRightBox = true;
      }
      $('html').addClass('scrollHide');
    });
    EventBus.$on('globalLoadingFun', (ob) => {
      that.isLoading = ob.bool;
      that.isLoadingShow = ob.loading;
    });
  },
  components: {
    'ui-anli': uiAnli,
    'ui-wechat': uiWechat,
    'ui-fangan': uiFangan,
    'ui-daohang': uiDaohang
  }
}
</script>

<style scoped lang="less">
#app{
  position: relative;
  min-height: 100%;
  .daohangBox{
    position: fixed;
    top: 30px;
    right: 20px;
    background: #FFFFFF;
    display: block;
    width: 45px;
    height: 45px;
    box-shadow: 0 0 1rem rgba(0, 0, 0, .1);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    i{
      font-size: 20px;
      color: #000000;
    }
  }
  .rightBox{
    position: fixed;
    height: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 4;
    display: flex;
    flex-direction: row-reverse;
    justify-content: right;
    .guanbiBtn{
      font-size: 32px;
      background: #000000;
      width: 50px;
      height: 50px;
      color: #FFFFFF;
      display: flex;
      justify-content: center;
      align-items: center;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
      margin-right: 20px;
      margin-top: 20px;
      border-radius: 50%;
      border: 2px solid #1E222E;
      i{
        font-size: 20px;
      }
    }
  }
  .jiazaiBox{
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
    span{
      background: #FFFFFF;
      width: 65px;
      height: 65px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 15px;
      box-shadow: 0 0 1rem rgba(0,0,0,.2);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue